<template>
  <v-container fluid class="pa-0">
    <CalendarSearchDialog v-model="calendarSearchOpen" :entries="calendarSearchEntries" :loading="calendarSearchLoading" :error="calendarSearchError" @select="openCalendarSearchResult" @reload="loadCalendarSearch" />

    <!-- HEADER / KPI CARD -->
    <v-card rounded="xl" elevation="3" class="pa-4 mb-4">
      <v-row align="center" class="mb-3">


        <v-col cols="12" sm="6" class="d-flex align-center">
          <v-avatar size="40" class="mr-3" color="primary">
            <v-icon>mdi-trending-up</v-icon>
          </v-avatar>
          <div>
            <div class="text-subtitle-1 font-weight-medium">
              Bike-Prognose
            </div>

          <v-chip size="small" color="blue-lighten-4" variant="tonal">
            ⌀ {{ Math.ceil(parseFloat(SchnittProTag) * 100) / 100 }} km / Tag - Resttage {{ DeltaTageBisEndeMonat }}
          </v-chip>



           <v-chip size="small" color="blue-lighten-4" variant="tonal">
            Monat: {{ DistanzAktuellerMonat.toFixed(0) }} km
          </v-chip>
          <v-chip size="small" color="blue-lighten-4" variant="tonal">
            Jahr: {{ DistanzAktuellesJahr.toFixed(0) }} km
          </v-chip>

          <v-chip size="small" color="yellow-lighten-3" variant="tonal">
            Monat: {{ PrognoseDistanzMonat.toFixed(0) }} km
          </v-chip>
          <v-chip size="small" color="yellow-lighten-3" variant="tonal">
            Jahr: {{ PrognoseDistanzJahr.toFixed(0)  }} km
          </v-chip>
          </div>


        </v-col>


        <v-col cols="12" sm="6" class="d-none d-sm-flex justify-sm-end">
          <div
            v-if="weatherToday"
            class="mini-weather-preview pa-3 rounded-lg border"
          >
            <div class="d-flex align-center justify-space-between ga-3">
              <div class="min-width-0">
                <div class="text-caption text-medium-emphasis text-truncate">
                  Wetter {{ weatherCityLabel }}
                </div>
                <div class="text-subtitle-2 font-weight-medium text-truncate">
                  {{ weatherToday.description }}
                </div>
              </div>
              <v-img
                v-if="weatherToday.icon"
                :src="'https://openweathermap.org/img/wn/' + weatherToday.icon + '@2x.png'"
                width="44"
                height="44"
                class="flex-grow-0"
              />
            </div>
            <div class="d-flex flex-wrap ga-2 mt-2">
              <v-chip size="small" color="blue-lighten-4" variant="tonal">
                {{ Math.round(weatherToday.temp) }}&deg;C
              </v-chip>
              <v-chip size="small" color="cyan-lighten-4" variant="tonal">
                {{ weatherToday.rainText }}
              </v-chip>
              <v-chip size="small" color="grey-lighten-3" variant="tonal">
                {{ weatherToday.windKmh }} km/h
              </v-chip>
            </div>
          </div>
          <div
            v-else
            class="mini-weather-preview pa-3 rounded-lg border text-caption text-medium-emphasis"
          >
            Keine Wetterdaten verf&uuml;gbar.
          </div>
        </v-col>


      </v-row>

    </v-card>
    <!-- KALENDER -->
    <v-row class="fill-height">
      <v-col>
        <v-sheet height="64" class="calendar-toolbar-sheet">
          <v-toolbar flat class="calendar-toolbar">
            <v-btn
              class="calendar-today-btn mr-3 d-none d-sm-inline-flex"
              color="primary"
              variant="flat"
              prepend-icon="mdi-calendar-today"
              @click="setToday"
            >
              Today
            </v-btn>
            <v-btn
              class="calendar-nav-btn mr-1"
              color="primary"
              variant="tonal"
              icon
              aria-label="Vorheriger Zeitraum"
              @click="prev"
            >
              <v-icon size="large">
                mdi-chevron-left
              </v-icon>
            </v-btn>
            <v-btn
              class="calendar-nav-btn"
              color="primary"
              variant="tonal"
              icon
              aria-label="Naechster Zeitraum"
              @click="next"
            >
              <v-icon size="large">
                mdi-chevron-right
              </v-icon>
            </v-btn>
            <v-toolbar-title class="calendar-month-title">
              {{ currentCalendarTitle }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn class="mr-2" variant="tonal" icon="mdi-magnify" aria-label="Kalendereinträge suchen" title="Kalendereinträge suchen" @click="openCalendarSearch" />
            <v-menu>
              <template #activator="{ props }">
                <v-btn v-bind="props" class="mr-2" variant="tonal" icon="mdi-printer" aria-label="Kalender drucken" title="Kalender drucken" />
              </template>
              <v-list>
                <v-list-item title="Monatsansicht mit Termindetails" prepend-icon="mdi-calendar-month" @click="printCalendar('month')" />
                <v-list-item title="Kompakte Jahresübersicht" prepend-icon="mdi-calendar" @click="printCalendar('year')" />
              </v-list>
            </v-menu>
            <v-btn-toggle
              v-model="calendarMode"
              mandatory
              density="compact"
              class="calendar-mode-toggle mr-2"
            >
              <v-btn value="month" size="small">
                Monat
              </v-btn>
              <v-btn value="year" size="small">
                Jahr
              </v-btn>
            </v-btn-toggle>
            <v-btn
              class="d-none d-sm-inline-flex"
              color="primary"
              variant="tonal"
              @click="openVacationDialog"
            >
              Kalendereintrag
            </v-btn>
            <v-btn
              class="d-inline-flex d-sm-none"
              color="primary"
              size="small"
              variant="tonal"
              icon
              @click="openVacationDialog"
            >
              <v-icon size="small">
                mdi-calendar-plus
              </v-icon>
            </v-btn>
          </v-toolbar>
        </v-sheet>

        <v-sheet
          v-if="calendarMode === 'month'"
          height="600"
          class="calendar-swipe-area"
          @touchstart.passive="onCalendarTouchStart"
          @touchend.passive="onCalendarTouchEnd"
        >
            <v-calendar
              ref="calendar"
              color="primary"
              v-model="value"
              :weekdays="weekday"
              :first-day-of-week="1"
              :view-mode="type"
              :events="events"
              @change="fetchEvents"
              :event-color="event => event.color"
              :event-text-color="event => event.textColor"
            >
              <template #event="{ event }">
                <div
                  class="d-flex align-center ga-2 px-1"
                  @click.stop="showEvent(event)"
                >
                  <v-avatar
                    v-if="getEventAvatar(event)"
                    size="24"
                    rounded="circle"
                    class="calendar-event-avatar elevation-2"
                  >
                    <v-img :src="getEventAvatar(event)" alt="Bike-Icon" cover />
                  </v-avatar>
                  <span class="calendar-event-name text-caption text-truncate">
                    {{ event.name }}
                  </span>
                </div>
              </template>
              <template #day="day">
                <div class="calendar-day-slot">
                  <v-tooltip
                    v-if="getCalendarEventsForTooltipDay(day).length"
                    location="top"
                    open-on-hover
                    open-on-focus
                  >
                    <template #activator="{ props }">
                      <button
                        v-bind="props"
                        type="button"
                        class="calendar-day-create-button"
                        :aria-label="'Kalendereintrag fuer ' + formatDateOnly(getDateFromCalendarDay(day)) + ' erstellen'"
                        @click.stop="openCalendarDay(getDateFromCalendarDay(day))"
                      ></button>
                    </template>

                    <div class="calendar-day-tooltip">
                      <div
                        v-for="event in getCalendarEventsForTooltipDay(day)"
                        :key="event.id || event.name"
                        class="calendar-day-tooltip__item"
                      >
                        {{ formatCalendarTooltipEvent(event) }}
                      </div>
                    </div>
                  </v-tooltip>

                  <button
                    v-else
                    type="button"
                    class="calendar-day-create-button"
                    :aria-label="'Kalendereintrag fuer ' + formatDateOnly(getDateFromCalendarDay(day)) + ' erstellen'"
                    @click.stop="openCalendarDay(getDateFromCalendarDay(day))"
                  ></button>

                </div>
              </template>
            </v-calendar>

        </v-sheet>
        <v-sheet
          v-else
          class="year-calendar-sheet calendar-swipe-area pa-4"
          @touchstart.passive="onCalendarTouchStart"
          @touchend.passive="onCalendarTouchEnd"
        >
          <div class="year-calendar-grid">
            <section
              v-for="month in yearCalendarMonths"
              :key="month.key"
              class="year-month"
            >
              <button
                type="button"
                class="year-month-title"
                @click="openMonth(month.month)"
              >
                {{ month.name }}
              </button>
              <div class="year-weekdays">
                <span
                  v-for="weekday in yearWeekdayLabels"
                  :key="weekday"
                >
                  {{ weekday }}
                </span>
              </div>
              <div class="year-days">
                <button
                  v-for="day in month.days"
                  :key="day.iso"
                  type="button"
                  class="year-day"
                  :class="{
                    'is-outside': day.outside,
                    'is-today': day.isToday,
                    'has-event': day.eventColors.length,
                    'is-vacation': day.isVacation,
                    'is-calendar-event': day.calendarEventColor,
                    'is-birthday': day.isBirthday,
                  }"
                  :style="getYearDayStyle(day)"
                  :tabindex="day.outside ? -1 : 0"
                  :aria-hidden="day.outside ? 'true' : 'false'"
                  :disabled="day.outside"
                  :title="getYearDayTooltip(day)"
                  @click="openCalendarYearDay(day.date)"
                >
                  <span
                    class="year-day-label"
                    :style="getYearDayLabelStyle(day)"
                  >{{ day.label }}</span>
                  <span
                    v-if="day.eventColors.length"
                    class="year-event-dots"
                  >
                    <span
                      v-for="color in day.eventColors"
                      :key="color"
                      class="year-event-dot"
                      :style="{ backgroundColor: color }"
                    ></span>
                  </span>
                </button>
              </div>
            </section>
          </div>
        </v-sheet>
      </v-col>
    </v-row>
    <!-- WETTER-WIDGET -->
    <v-card class="mt-4">
<v-row class="mb-4">
  <!-- KLEINE WETTER-KARTE (links) -->
  <v-col cols="12" md="4">
    <v-card class="mx-auto" max-width="368">
      <div v-if="weatherToday">
        <v-card-item :title="'Wetter heute (' + weatherCityLabel + ')'">
          <template #subtitle>

            {{ weatherToday.description }}
          </template>
        </v-card-item>

        <v-card-text class="py-0">
          <v-row align="center" no-gutters>
            <v-col class="text-h5" cols="6">
              {{ Math.round(weatherToday.temp) }}&deg;C
            </v-col>

            <v-col class="text-right" cols="6">
              <v-img
                v-if="weatherToday.icon"
                :src="'https://openweathermap.org/img/wn/' + weatherToday.icon + '@2x.png'"
                width="50"
                height="50"
                class="mr-2"
              />
            </v-col>
          </v-row>
          Gefühlte Temperatur:
          {{ Math.round(weatherToday.feelsLike) }}&deg;C
        </v-card-text>

        <v-row class="py-3">
          <v-col cols="6">
            <v-list-item density="compact" prepend-icon="mdi-weather-windy">
              <v-list-item-subtitle>
                {{ weatherToday.windKmh }} km/h
                <span v-if="weatherToday.windDir">({{ weatherToday.windDir }})</span>
              </v-list-item-subtitle>
            </v-list-item>
          </v-col>

          <v-col cols="6">
            <v-list-item
                  density="compact"
                  :prepend-icon="weatherIconMdi(weatherToday)"
                >
              <v-list-item-subtitle>
                Regenrisiko:
                <strong>{{ weatherToday.rainText }}</strong>
              </v-list-item-subtitle>
            </v-list-item>
          </v-col>
        </v-row>


      </div>

      <div v-else class="pa-4 text-caption text-medium-emphasis">
        Keine Wetterdaten verf&uuml;gbar.
      </div>
    </v-card>
  </v-col>

  <!-- 🔮 VORHERSAGE 3 TAGE (rechts, im selben Stil wie oben) -->
  <v-col cols="12" md="8">
    <v-card rounded="xl" elevation="2" class="pa-4">
      <div class="text-subtitle-2 mb-2">
        Vorhersage (nächste 3 Tage)
      </div>

      <v-row v-if="weatherForecast && weatherForecast.length">
        <v-col
          v-for="day in weatherForecast"
          :key="day.date"
          cols="12"
          md="4"
        >
          <v-card variant="flat" class="pa-3">
            <v-card-item :title="day.dateLabel">
              <template #subtitle>
                {{ day.description }}
              </template>
            </v-card-item>

            <v-card-text class="py-0">
              <v-row align="center" no-gutters>
                <v-col cols="6">
                  <div class="text-h5">
                    {{ Math.round(day.max) }}&deg;C
                  </div>
                  <div class="text-caption text-medium-emphasis">
                    Min: {{ Math.round(day.min) }}&deg;C
                  </div>
                </v-col>

                <v-col class="text-right" cols="6">
                      <v-img
                        v-if="day.icon"
                        :src="'https://openweathermap.org/img/wn/' + day.icon + '@2x.png'"
                        width="50"
                        height="50"
                        class="mr-2"
                      />
                </v-col>
              </v-row>

              <div class="d-flex py-2 justify-space-between">
                <v-list-item
                  density="compact"
                  :prepend-icon="weatherIconMdi(day)"
                >
                  <v-list-item-subtitle>
                    Regenrisiko:
                    <strong>{{ day.rainText }}</strong>
                  </v-list-item-subtitle>
                </v-list-item>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <div v-else class="text-caption text-medium-emphasis">
        Keine Vorhersage verf&uuml;gbar.
      </div>
    </v-card>
  </v-col>
</v-row>

</v-card>


    <!-- GEBUENDELTE LEGENDE -->
    <v-card variant="outlined" rounded="xl" class="pa-4 mt-4">
      <v-row>
        <v-col cols="12" md="6">
          <div class="text-subtitle-2 mb-2">
            Legende Trainings-Effekt (Aerob)
          </div>

          <div class="d-flex flex-wrap ga-2">
            <v-chip
              size="small"
              style="background-color:#FFFFFF; color:#000000"
            >
              Keine Wirkung (&lt; 1.0)
            </v-chip>

            <v-chip
              size="small"
              style="background-color:#C6EFCE; color:#006100"
            >
              Erholung (Leicht Aerob) (1.0–1.9)
            </v-chip>

            <v-chip
              size="small"
              style="background-color:#C6EFCE; color:#006100"
            >
              Basis (Leicht Aerob) (2.0–3.5)
            </v-chip>

            <v-chip
              size="small"
              style="background-color:#EDBA77; color:#0a0a0a"
            >
              Pace (Hoch Aerob) (3.6–3.9)
            </v-chip>

            <v-chip
              size="small"
              style="background-color:#EDBA77; color:#0a0a0a"
            >
              Schwelle (Hoch Aerob) (4.0–4.9)
            </v-chip>

            <v-chip
              size="small"
              style="background-color:#FFC7CE; color:#9C0006"
            >
              Überbelastung (≥ 5.0)
            </v-chip>
          </div>
        </v-col>

        <v-col cols="12" md="6">
          <div class="text-subtitle-2 mb-2">
            Legende Aktivitätstypen
          </div>

          <div class="d-flex flex-wrap ga-4">
            <div
              v-for="item in bikeLegend"
              :key="item.label"
              class="d-flex align-center ga-2"
            >
              <v-avatar size="32" rounded="circle" class="elevation-2">
                <v-img :src="item.icon" alt="activity-icon" cover />
              </v-avatar>
              <span class="text-body-2">{{ item.label }}</span>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-card>

      <v-divider class="mb-3"></v-divider>

      <v-row>
        <v-col cols="12" md="6">
          <div class="text-caption text-medium-emphasis">
            Letzter Bike-Tag
          </div>
          <div class="text-body-1">
            {{ DatumDerLetztenAktivity
              ? formatDateTime(DatumDerLetztenAktivity)
              : DatumDerLetztenAktivity || '—' }}
          </div>

          <div class="text-caption text-medium-emphasis">
              Letztes Garmin-Update:
              {{ LastGarminLoginDisplay !== '—' ? LastGarminLoginDisplay : LastGarminLogin }}

           </div>


        </v-col>

        <v-col cols="12" md="3">
          <div class="text-caption text-medium-emphasis">
            Resttage im Monat
          </div>
          <div class="text-body-1">
            {{ DeltaTageBisEndeMonat }}
          </div>
        </v-col>

      </v-row>

    <!-- 🔍 EVENT-DETAIL-DIALOG -->
    <v-dialog v-model="eventDetailsDialog" max-width="480">
      <v-card rounded="xl">
        <v-card-title class="d-flex align-center ga-3">
          <v-avatar
            v-if="selectedEvent && getEventAvatar(selectedEvent)"
            size="36"
            rounded="circle"
            class="elevation-2"
          >
            <v-img :src="getEventAvatar(selectedEvent)" alt="Bike-Icon" cover />
          </v-avatar>

          <div>
            <div class="text-subtitle-1 font-weight-medium">
              {{ selectedEvent ? selectedEvent.name : 'Aktivität' }}
            </div>
            <div class="text-caption text-medium-emphasis" v-if="selectedEvent">
              {{ formatDateTime(selectedEvent.start) }}
            </div>
          </div>

          <v-spacer></v-spacer>

          <v-btn icon variant="text" @click="eventDetailsDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

<v-card-text v-if="selectedEvent" class="pa-0" style="max-height: 380px; overflow-y: auto;">
  <v-data-table
    :headers="eventDetailHeaders"
    :items="eventDetailRows"
    density="compact"
    hide-default-footer
    :items-per-page="-1"
  >
    <template #item.value="{ item }">
      <span>{{ item.value }}</span>
    </template>
  </v-data-table>
</v-card-text>

        <v-card-actions>
          <v-btn
            v-if="selectedEvent && selectedEvent.sourceType === 'calender'"
            color="error"
            variant="text"
            @click="deleteSelectedVacation"
          >
            Löschen
          </v-btn>
          <v-btn
            v-if="selectedEvent && selectedEvent.sourceType === 'calender'"
            color="primary"
            variant="text"
            @click="editSelectedVacation"
          >
            Bearbeiten
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" variant="tonal" @click="eventDetailsDialog = false">
            Schließen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="vacationDialog" max-width="520">
      <v-card rounded="xl">
        <v-card-title>Kalendereintrag</v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols="12">
              <v-select
                v-model="vacationForm.entryType"
                :items="calendarEntryTypeOptions"
                item-title="text"
                item-value="value"
                label="Typ"
                @update:model-value="onCalendarEntryTypeChange"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="vacationForm.name"
                label="Bezeichnung"
                placeholder="z. B. Urlaub Italien oder Geburtstag"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="vacationForm.startDate"
                label="Startdatum"
                type="date"
                @update:model-value="onVacationStartDateChange"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="vacationForm.endDate"
                label="Enddatum"
                type="date"
                :min="vacationForm.startDate || undefined"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-select
                v-model="vacationForm.recurrence"
                :items="recurrenceOptions"
                item-title="text"
                item-value="value"
                label="Wiederholung"
                density="compact"
              />
            </v-col>
            <v-col v-if="showVacationTimeFields" cols="12" md="6">
              <v-text-field
                v-model="vacationForm.startTime"
                label="Startzeit"
                type="time"
                @update:model-value="onVacationStartTimeChange"
              />
            </v-col>
            <v-col v-if="showVacationTimeFields" cols="12" md="6">
              <v-text-field
                v-model="vacationForm.endTime"
                label="Endzeit"
                type="time"
                :min="vacationForm.startTime || undefined"
                @update:model-value="ensureVacationEndTimeAfterStart"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-switch
                v-model="vacationForm.reminderEnabled"
                label="Erinnerung aktiv"
                density="compact"
                hide-details
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-select
                v-model="vacationForm.reminderMinutesBefore"
                :items="reminderMinuteOptions"
                item-title="text"
                item-value="value"
                label="Erinnern vor"
                density="compact"
                :disabled="!vacationForm.reminderEnabled"
                hide-details
              />
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="vacationForm.note"
                label="Notiz"
                rows="2"
                auto-grow
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn variant="text" @click="closeVacationDialog">abbrechen</v-btn>
          <v-btn color="primary" variant="tonal" @click="saveVacationDraft(false)">
            speichern
          </v-btn>
          <v-btn color="primary" variant="flat" @click="saveVacationDraft(true)">
            speichern&schließen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { Chart, registerables } from "chart.js";
import _ from 'lodash';                        // wieder rein
import indoorIcon from '@/assets/indoor_cycling.png';
import CalendarSearchDialog from '@/components/CalendarSearchDialog.vue';
import { buildCalendarPrintHtml, printCalendarHtml } from '@/utils/calendarPrint';
import mtbIcon from '@/assets/mountain_biking.png';
import roadIcon from '@/assets/road_biking.png';
Chart.register(...registerables);

const MS_PER_DAY = 24 * 60 * 60 * 1000;

function toKm(meters) { return meters / 1000; }
function clamp(n, min, max) { return Math.max(min, Math.min(max, n)); }

const EVENT_DETAIL_FIELD_DEFS = [
  { key: 'aktivitaeten_activityName',        label: 'Name' },
  { key: 'aktivitaeten_Anmerkung',           label: 'Anmerkung' },
  { key: 'aktivitaeten_activityType',        label: 'Typ' },
  { key: 'aktivitaeten_startTimeGMT',        label: 'Startzeit' },
  // ⬇⬇⬇ HIER angepasst
  { key: 'aktivitaeten_distance',            label: 'Distanz (km)' },
  { key: 'aktivitaeten_duration',            label: 'Dauer' },
  { key: 'aktivitaeten_movingDuration',      label: 'Bewegungsdauer' },

  { key: 'aktivitaeten_movingaverageSpeed',  label: 'Ø Bewegungs-Geschw. (km/h)' },
  { key: 'aktivitaeten_averageSpeed',        label: 'Ø Geschw. (km/h)' },
  { key: 'aktivitaeten_maxSpeed',            label: 'Max. Geschw. (km/h)' },

  { key: 'aktivitaeten_averageHR',           label: 'Ø HF' },
  { key: 'aktivitaeten_maxHR',               label: 'Max. HF' },

  { key: 'aktivitaeten_Zone1_lowb',          label: 'Zone1 Untergrenze' },
  { key: 'aktivitaeten_Zone1_secs',          label: 'Zone1 Sekunden' },
  { key: 'aktivitaeten_Zone2_lowb',          label: 'Zone2 Untergrenze' },
  { key: 'aktivitaeten_Zone2_secs',          label: 'Zone2 Sekunden' },
  { key: 'aktivitaeten_Zone3_lowb',          label: 'Zone3 Untergrenze' },
  { key: 'aktivitaeten_Zone3_secs',          label: 'Zone3 Sekunden' },
  { key: 'aktivitaeten_Zone4_lowb',          label: 'Zone4 Untergrenze' },
  { key: 'aktivitaeten_Zone4_secs',          label: 'Zone4 Sekunden' },
  { key: 'aktivitaeten_Zone5_lowb',          label: 'Zone5 Untergrenze' },
  { key: 'aktivitaeten_Zone5_secs',          label: 'Zone5 Sekunden' },

  { key: 'aktivitaeten_aerobicTrainingEffect',    label: 'Aerober Trainingseffekt' },
  { key: 'aktivitaeten_anaerobicTrainingEffect',  label: 'Anaerober Trainingseffekt' },
  { key: 'aktivitaeten_trainingStressScore',      label: 'Training Stress Score' },
  { key: 'aktivitaeten_vO2MaxValue',              label: 'VO2max' },

  { key: 'aktivitaeten_calories',            label: 'Kalorien' },
  { key: 'aktivitaeten_deviceId',            label: 'Geräte-ID' },
  { key: 'aktivitaeten_ownerFullName',       label: 'Athlet' },

  { key: 'aktivitaeten_startLatitude',       label: 'Start-Breite' },
  { key: 'aktivitaeten_startLongitude',      label: 'Start-Länge' },

  { key: 'aktivitaeten_minElevation',        label: 'Min. Höhe' },
  { key: 'aktivitaeten_maxElevation',        label: 'Max. Höhe' },
  { key: 'aktivitaten_elevationGain',        label: 'Anstieg (m)' },
  { key: 'aktivitaten_elevationLoss',        label: 'Abstieg (m)' },

  { key: 'aktivitaeten_averageBikingCadenceInRevPerMinute', label: 'Ø Trittfrequenz' },
  { key: 'aktivitaeten_avgPower',            label: 'Ø Leistung' },
  { key: 'aktivitaeten_max20MinPower',       label: 'Max 20 Min Power' },
  { key: 'aktivitaeten_maxPower',            label: 'Max Leistung' },
  { key: 'aktivitaeten_normPower',           label: 'Normierte Leistung' },
  { key: 'aktivitaeten_intensityFactor',     label: 'Intensitätsfaktor' },
  { key: 'aktivitaeten_maxFtp',              label: 'Max FTP' },

  { key: 'aktivitaeten_minTemperature',      label: 'Min. Temperatur' },
  { key: 'aktivitaeten_maxTemperature',      label: 'Max. Temperatur' },

  { key: 'aktivitaten_activityId',           label: 'Activity-ID' },
  { key: 'idaktivitaeten',                   label: 'DB-ID' },
];

function formatKm(meters) {
  const v = Number(meters);
  if (!Number.isFinite(v)) return '—';
  return (v / 1000).toFixed(1) + ' km';
}

function formatDurationSecondsToHm(seconds) {
  const v = Number(seconds);
  if (!Number.isFinite(v)) return '—';

  const total = Math.round(v);
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);

  if (hours <= 0) {
    return `${minutes} min`;
  }
  return `${hours} h ${minutes} min`;
}

function formatSpeedMsToKmh(ms) {
  const v = Number(ms);
  if (!Number.isFinite(v)) return '—';
  return (v * 3.6).toFixed(1) + ' km/h';
}


// ISO week number + week-year (not the same as calendar year)
function isoWeekKey(d) {
  const date = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  // Thursday in current week decides the year.
  const dayNum = (date.getUTCDay() + 6) % 7; // Mon=0..Sun=6
  date.setUTCDate(date.getUTCDate() - dayNum + 3);
  const weekYear = date.getUTCFullYear();
  // Jan 4 is always in week 1.
  const jan4 = new Date(Date.UTC(weekYear, 0, 4));
  // Number of days between jan4 and current Thursday
  const weekNo = 1 + Math.round(((date - jan4) / MS_PER_DAY - 3) / 7);
  return `${weekYear}_${weekNo}`;
}

function yearMonthKey(d) {
  return `${d.getFullYear()}_${String(d.getMonth() + 1).padStart(2, '0')}`;
}

function sortGroupedKeysChronoDesc(group, parser) {
  return Object.keys(group).sort((a, b) => parser(b) - parser(a));
}

function defaultVacationForm() {
  return {
    name: 'Urlaub',
    startDate: '',
    endDate: '',
    startTime: '',
    endTime: '',
    note: '',
    recurrence: 'none',
    entryKind: 'vacation',
    eventType: '',
    entryType: 'vacation',
    reminderEnabled: true,
    reminderMinutesBefore: 15,
  };
}

function firstDefined(source, keys) {
  for (const key of keys) {
    if (source?.[key] !== undefined && source?.[key] !== null) {
      return source[key];
    }
  }
  return undefined;
}

function toIsoDateString(value) {
  if (!value) return '';
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}/.test(value)) {
    return value.slice(0, 10);
  }
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return date.toISOString().slice(0, 10);
}

export default {
  name: 'CalendarScreen',
  components: { CalendarSearchDialog },
  data () {
    return {
      DistanzVorletzteWoche: 0,
      DistanzAktuellerMonat: 0,
      DistanzAktuellesJahr: 0,
      PrognoseDistanzMonat: 0,
      PrognoseDistanzJahr: 0,
      DistanzProTag: 0,
      SchnittProTag: 0,
      SchnittProMonat: 0,
      DatumDerLetztenAktivity: null,
      DeltaTageBisEndeMonat: 0,
      LastGarminLogin: null,
      LastGarminLoginDisplay: '—',
      LastGarminLoginUhrzeit: '—',
      array_allActivities: [],
      aktuellerMonat: '...',
      calendarMode: 'month',
      calendarSearchOpen: false,
      calendarSearchLoading: false,
      calendarSearchError: '',
      type: 'month',
      types: ['month', 'week', 'day'],
      weekday: [1, 2, 3, 4, 5, 6, 0],
      weekdays: [
        { title: 'Sun - Sat', value: [0, 1, 2, 3, 4, 5, 6] },
        { title: 'Mon - Sun', value: [1, 2, 3, 4, 5, 6, 0] },
        { title: 'Mon - Fri', value: [1, 2, 3, 4, 5] },
        { title: 'Mon, Wed, Fri', value: [1, 3, 5] },
      ],
      bikeLegend: [
        { label: 'Indoor Cycling', icon: indoorIcon },
        { label: 'Mountainbike', icon: mtbIcon },
        { label: 'Rennrad', icon: roadIcon },
      ],
      calendarEntryTypeOptions: [
        { text: 'Urlaub', value: 'vacation' },
        { text: 'Geburtstag', value: 'Geburtstag' },
        { text: 'Termin', value: 'Termin' },
        { text: 'Feiertag', value: 'Feiertag' },
        { text: 'Erinnerung', value: 'Erinnerung' },
        { text: 'Familie', value: 'Familie' },
      ],
      recurrenceOptions: [
        { text: 'Keine Wiederholung', value: 'none' },
        { text: 'Täglich', value: 'daily' },
        { text: 'Wöchentlich', value: 'weekly' },
        { text: 'Monatlich', value: 'monthly' },
        { text: 'Jährlich', value: 'yearly' },
      ],
      reminderMinuteOptions: [
        { text: 'Zur Startzeit', value: 0 },
        { text: '1 Stunde', value: 60 },
        { text: '1 Tag', value: 1440 },
        { text: '2 Wochen', value: 20160 },
        { text: '2 Monate', value: 86400 },
      ],
      eventTypeOptions: [
        'Geburtstag',
        'Termin',
        'Feiertag',
        'Erinnerung',
        'Familie',
      ],
      value: new Date(),
      events: [],
      colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'],
      titles: ['Meeting', 'Holiday', 'PTO', 'Travel', 'Event', 'Birthday', 'Conference', 'Party'],
      headers: [
        { title: 'Zeitraum', align: 'start', sortable: false, key:'Zeitraum', width: 20 },
        { title: 'kmDone', align: 'start', key:'kmDone', width: 20 },
        { title: 'kmPrognose', align: 'start', key:'kmPrognose' },
      ],

      // 🔍 neu für Dialog
      eventDetailsDialog: false,
      selectedEvent: null,
      vacationDialog: false,
      vacationForm: defaultVacationForm(),
      editingVacationId: null,
      // 🌦 Wetter
      weatherToday: null,
      weatherForecast: [],
      weatherLoading: false,
      weatherError: null,
      weatherCity: 'Plochingen,de',     // hier beliebig anpassen
      weatherCityLabel: 'Plochingen',   // Anzeige im UI
      weatherApiKey: 'aussettings', // OpenWeatherMap API-Key
      calendarTouchStartX: null,
      calendarTouchStartY: null,
      calendarTouchStartTime: 0,

    };
  },
  computed: {
    calendarSearchEntries() {
      return (Array.isArray(this.calenderEntries) ? this.calenderEntries : []).map(entry => this.normalizeCalenderEntry(entry));
    },
    ...mapGetters({
      activities: 'stateActivities',
      settings: 'stateSettings',
      calenderEntries: 'stateCalenderEntries',
    }),
    statistics() {
      return [
        { Zeitraum: 'km/Monat', kmDone: this.DistanzAktuellerMonat.toFixed(1), kmPrognose: this.PrognoseDistanzMonat.toFixed(0) },
        { Zeitraum: 'km/Jahr',  kmDone: this.DistanzAktuellesJahr.toFixed(1),  kmPrognose: this.PrognoseDistanzJahr.toFixed(0)  },
      ];
    },
    currentMonthTitle() {
      if (this.$refs.calendar && this.$refs.calendar.title) {
        return this.$refs.calendar.title;
      }
      const raw = Array.isArray(this.value) ? this.value[0] : this.value;
      const dt = raw instanceof Date ? raw : new Date(raw || Date.now());
      return new Intl.DateTimeFormat('de-DE', {
        month: 'long',
        year: 'numeric',
      }).format(dt);
    },
    currentCalendarTitle() {
      if (this.calendarMode === 'year') {
        return String(this.selectedCalendarYear);
      }
      return this.currentMonthTitle;
    },
    selectedCalendarYear() {
      const raw = Array.isArray(this.value) ? this.value[0] : this.value;
      const dt = raw instanceof Date ? raw : new Date(raw || Date.now());
      return Number.isNaN(dt.getTime()) ? new Date().getFullYear() : dt.getFullYear();
    },
    yearWeekdayLabels() {
      return ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'];
    },
    yearCalendarMonths() {
      return Array.from({ length: 12 }, (_unused, month) => this.buildYearCalendarMonth(month));
    },
    eventDetailHeaders() {
  return [
    { title: 'Feld', key: 'label', width: 200 },
    { title: 'Wert', key: 'value' },
  ];
},

eventDetailRows() {
  if (!this.selectedEvent) return [];

  if (this.selectedEvent.sourceType === 'calender') {
    return [
      { label: 'Art', value: this.selectedEvent.isEvent ? 'Event' : 'Urlaub / Blocker' },
      { label: 'Bezeichnung', value: this.selectedEvent.name || 'Eintrag' },
      { label: 'Von', value: this.formatDateOnly(this.selectedEvent.start) },
      { label: 'Bis', value: this.formatDateOnly(this.selectedEvent.displayEnd || this.selectedEvent.end) },
      { label: 'Startzeit', value: this.selectedEvent.startTime ? this.formatTimeOnly(this.selectedEvent.startTime) : 'â€”' },
      { label: 'Endzeit', value: this.selectedEvent.endTime ? this.formatTimeOnly(this.selectedEvent.endTime) : 'â€”' },
      { label: 'Wiederholung', value: this.getRecurrenceLabel(this.selectedEvent.recurrence) },
      { label: 'Event-Typ', value: this.selectedEvent.eventType || '—' },
      { label: 'Notiz', value: this.selectedEvent.note || '—' },
    ];
  }

  if (!this.selectedEvent.full) return [];

  const src = this.selectedEvent.full;

  return EVENT_DETAIL_FIELD_DEFS.map(def => {
    const raw = src[def.key];

    let value;
    switch (def.key) {
      case 'aktivitaeten_startTimeGMT':
        value = this.formatDateTime(raw);
        break;

      case 'aktivitaeten_distance':
        value = formatKm(raw);
        break;

      case 'aktivitaeten_duration':
      case 'aktivitaeten_movingDuration':
        value = formatDurationSecondsToHm(raw);
        break;

      case 'aktivitaeten_averageSpeed':
      case 'aktivitaeten_movingaverageSpeed':
      case 'aktivitaeten_maxSpeed':
        value = formatSpeedMsToKmh(raw);
        break;

      default:
        value = raw ?? '—';
    }

    return {
      label: def.label,
      value,
    };
  });
},
    showVacationTimeFields() {
      return this.isTimedCalendarEntryType(this.vacationForm.entryType);
    },
  },
  mounted() {
    const today = new Date();
    this.aktuellerMonat = today.toLocaleString('de-DE', { month: 'long' });

    this.fetchWeather(); // 🌦 Wetter laden
  },
  methods: {
    openCalendarSearch() {
      this.calendarSearchOpen = true;
      this.loadCalendarSearch();
    },
    async loadCalendarSearch() {
      if (this.calendarSearchLoading) return;
      this.calendarSearchLoading = true;
      this.calendarSearchError = '';
      try { await this.getCalenderEntries(); }
      catch { this.calendarSearchError = 'Kalendereinträge konnten nicht aktualisiert werden. Bitte erneut versuchen.'; }
      finally { this.calendarSearchLoading = false; }
    },
    openCalendarSearchResult(entry) {
      this.calendarSearchOpen = false;
      this.showEvent({
        ...entry,
        sourceType: 'calender',
        start: this.buildCalenderDateTime(entry.startDate, entry.startTime),
        end: this.buildCalenderDateTime(entry.endDate || entry.startDate, entry.endTime),
        full: entry.raw,
      });
    },
    printCalendar(mode) {
      const raw = Array.isArray(this.value) ? this.value[0] : this.value;
      const date = raw instanceof Date ? raw : new Date(raw || Date.now());
      const rangeStart = new Date(date.getFullYear(), mode === 'year' ? 0 : date.getMonth(), 1);
      const rangeEnd = new Date(date.getFullYear(), mode === 'year' ? 12 : date.getMonth() + 1, 1);
      rangeEnd.setMilliseconds(-1);
      const events = this.buildVacationEvents({ rangeStart, rangeEnd });
      printCalendarHtml(buildCalendarPrintHtml({ date, mode, events }));
    },

    ...mapActions([
      'createStock',
      'getCalenderEntries',
      'createCalenderEntry',
      'updateCalenderEntry',
      'deleteCalenderEntry',
    ]),

    // 📅 Datum hübsch formatieren
    formatDateTime(d) {
      if (!d) return '—';
      const date = d instanceof Date ? d : new Date(d);
      return date.toLocaleString('de-DE', {
        dateStyle: 'medium',
        timeStyle: 'short',
      });
    },
    formatDateOnly(d) {
      if (!d) return '—';
      const date = d instanceof Date ? d : new Date(d);
      if (Number.isNaN(date.getTime())) return '—';
      return date.toLocaleDateString('de-DE');
    },
    formatTimeOnly(value) {
      const normalized = this.normalizeTimeValue(value);
      return normalized ? normalized.slice(0, 5) : 'â€”';
    },
    formatCalendarEventName(entry) {
      const time = entry?.startTime ? `${this.formatTimeOnly(entry.startTime)} ` : '';
      return `${time}${entry?.name || 'Kalendereintrag'}`;
    },
    formatCalendarTooltipEvent(event) {
      if (!event) return '';
      const time = event.startTime || event.endTime
        ? `${this.formatTimeOnly(event.startTime)}${event.endTime ? `-${this.formatTimeOnly(event.endTime)}` : ''} `
        : '';
      return `${time}${event.name || 'Kalendereintrag'}`.trim();
    },
    getRecurrenceLabel(recurrence) {
      const value = String(recurrence || 'none').toLowerCase();
      const match = this.recurrenceOptions.find((item) => item.value === value);
      return match?.text || value;
    },
    toLocalIsoDate(date) {
      return [
        date.getFullYear(),
        String(date.getMonth() + 1).padStart(2, '0'),
        String(date.getDate()).padStart(2, '0'),
      ].join('-');
    },
    buildYearCalendarMonth(month) {
      const year = this.selectedCalendarYear;
      const firstOfMonth = new Date(year, month, 1);
      const gridStart = new Date(firstOfMonth);
      const firstWeekdayOffset = (firstOfMonth.getDay() + 6) % 7;
      gridStart.setDate(gridStart.getDate() - firstWeekdayOffset);
      const todayIso = this.toLocalIsoDate(new Date());

      return {
        key: `${year}-${month}`,
        month,
        name: new Intl.DateTimeFormat('de-DE', { month: 'long' }).format(firstOfMonth),
        days: Array.from({ length: 42 }, (_unused, index) => {
          const date = new Date(gridStart);
          date.setDate(gridStart.getDate() + index);
          const iso = this.toLocalIsoDate(date);

          return {
            date,
            iso,
            label: date.getDate(),
            outside: date.getMonth() !== month,
            isToday: iso === todayIso,
            isVacation: date.getMonth() === month && this.hasVacationOnDate(date),
            isBirthday: date.getMonth() === month && this.hasBirthdayOnDate(date),
            calendarEventColor: date.getMonth() === month ? this.getCalenderEventRingColorOnDate(date) : '',
            eventColors: date.getMonth() === month ? this.getYearEventColorsOnDate(date) : [],
            tooltip: date.getMonth() === month ? this.getCalendarEventsForTooltipDate(date) : [],
          };
        }),
      };
    },
    getYearDayTooltip(day) {
      if (!day || day.outside) return '';
      const events = Array.isArray(day.tooltip) ? day.tooltip : this.getCalendarEventsForTooltipDate(day.date);
      return events.map((event) => this.formatCalendarTooltipEvent(event)).join('\n');
    },
    getYearDayStyle(day) {
      if (!day?.calendarEventColor || !day.isToday) return undefined;
      return {
        boxShadow: `0 0 0 3px ${day.calendarEventColor}`,
      };
    },
    getYearDayLabelStyle(day) {
      if (!day?.calendarEventColor) return undefined;
      return {
        boxShadow: day.isToday
          ? '0 0 0 2px #FFFFFF inset'
          : `0 0 0 2px ${day.calendarEventColor} inset`,
      };
    },
    getYearEventColorsOnDate(date) {
      const dayStart = new Date(date.getFullYear(), date.getMonth(), date.getDate());
      const dayEnd = new Date(dayStart);
      dayEnd.setHours(23, 59, 59, 999);

      const colors = [];
      const addColor = (color) => {
        if (color && !colors.includes(color) && colors.length < 3) {
          colors.push(color);
        }
      };

      (Array.isArray(this.events) ? this.events : []).forEach((event) => {
        if (event.sourceType === 'calender' && !event.isEvent) return;

        const start = event.start instanceof Date ? event.start : new Date(event.start);
        const rawEnd = event.displayEnd || event.end || event.start;
        const end = rawEnd instanceof Date ? rawEnd : new Date(rawEnd);

        if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) {
          return;
        }

        const eventStart = new Date(start.getFullYear(), start.getMonth(), start.getDate());
        const eventEnd = new Date(end.getFullYear(), end.getMonth(), end.getDate(), 23, 59, 59, 999);
        if (eventStart <= dayEnd && eventEnd >= dayStart) {
          addColor(event.color);
        }
      });

      this.getCalenderEntryColorsOnDate(dayStart).forEach(addColor);
      return colors;
    },
    getCalenderEntryColorsOnDate(dayStart) {
      const colors = [];

      (Array.isArray(this.calenderEntries) ? this.calenderEntries : [])
        .map((entry) => this.normalizeCalenderEntry(entry))
        .forEach((entry) => {
          if (!entry.isEvent) return;
          if (this.isCalenderEntryOnDate(entry, dayStart)) {
            colors.push(this.getCalenderEventStyle(entry).color);
          }
        });

      return colors;
    },
    hasCalenderEntryOnDate(dayStart, predicate = () => true) {
      return (Array.isArray(this.calenderEntries) ? this.calenderEntries : [])
        .map((entry) => this.normalizeCalenderEntry(entry))
        .some((entry) => {
          if (!predicate(entry)) return false;
          return this.isCalenderEntryOnDate(entry, dayStart);
        });
    },
    isCalenderEntryOnDate(entry, dayStart) {
      if (!entry.startDate || !entry.endDate) return false;

      const baseStart = new Date(`${entry.startDate}T00:00:00`);
      const baseEnd = new Date(`${entry.endDate}T00:00:00`);
      if (Number.isNaN(baseStart.getTime()) || Number.isNaN(baseEnd.getTime())) return false;

      const durationDays = Math.max(
        0,
        Math.round((baseEnd.getTime() - baseStart.getTime()) / MS_PER_DAY)
      );

      let occurrenceStart = new Date(baseStart);
      let guard = 0;

      while (occurrenceStart <= dayStart && guard < 500) {
        const occurrenceEnd = new Date(occurrenceStart);
        occurrenceEnd.setDate(occurrenceEnd.getDate() + durationDays);

        if (occurrenceStart <= dayStart && occurrenceEnd >= dayStart) {
          return true;
        }

        if (entry.recurrence === 'none') return false;

        const next = this.addRecurrenceStep(occurrenceStart, entry.recurrence);
        if (!next || next <= occurrenceStart) return false;
        occurrenceStart = next;
        guard += 1;
      }

      return false;
    },
    hasVacationOnDate(date) {
      const dayStart = new Date(date.getFullYear(), date.getMonth(), date.getDate());
      return this.hasCalenderEntryOnDate(dayStart, (entry) => !entry.isEvent);
    },
    hasBirthdayOnDate(date) {
      const dayStart = new Date(date.getFullYear(), date.getMonth(), date.getDate());
      return this.hasCalenderEntryOnDate(
        dayStart,
        (entry) => entry.isEvent && this.isBirthdayEventType(entry.eventType)
      );
    },
    getDateFromCalendarDay(day) {
      const raw = day?.date || day;
      if (typeof raw === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(raw)) {
        return new Date(`${raw}T00:00:00`);
      }

      const date = raw instanceof Date ? raw : new Date(raw);
      return Number.isNaN(date.getTime()) ? null : date;
    },
    getCalendarEventsForTooltipDay(day) {
      return this.getCalendarEventsForTooltipDate(this.getDateFromCalendarDay(day));
    },
    getCalendarEventsForTooltipDate(date) {
      if (!date) return [];

      const dayStart = new Date(date.getFullYear(), date.getMonth(), date.getDate());
      const dayEnd = new Date(dayStart);
      dayEnd.setHours(23, 59, 59, 999);
      const calendarEvents = (Array.isArray(this.calenderEntries) ? this.calenderEntries : [])
        .map((entry) => this.normalizeCalenderEntry(entry))
        .filter((entry) => this.isCalenderEntryOnDate(entry, dayStart))
        .map((entry) => {
          const style = this.getCalenderEventStyle(entry);
          return {
            id: `tooltip_${entry.id}_${this.toLocalIsoDate(dayStart)}`,
            calenderEntryId: entry.id,
            name: this.formatCalendarEventName(entry),
            start: new Date(dayStart),
            end: new Date(dayStart),
            displayEnd: new Date(dayStart),
            color: style.color,
            textColor: style.textColor,
            allDay: !entry.startTime && !entry.endTime,
            sourceType: 'calender',
            note: entry.note || '',
            startTime: entry.startTime || '',
            endTime: entry.endTime || '',
            recurrence: entry.recurrence || 'none',
            isEvent: entry.isEvent,
            eventType: entry.eventType || '',
            full: entry.raw,
          };
        });
      const activityEvents = (Array.isArray(this.events) ? this.events : [])
        .filter((event) => event.sourceType !== 'calender')
        .filter((event) => {
          const start = event.start instanceof Date ? event.start : new Date(event.start);
          const rawEnd = event.end || event.start;
          const end = rawEnd instanceof Date ? rawEnd : new Date(rawEnd);
          if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) return false;
          return start <= dayEnd && end >= dayStart;
        })
        .map((event) => ({
          ...event,
          startTime: event.start instanceof Date
            ? event.start.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' })
            : '',
        }));

      return [...calendarEvents, ...activityEvents];
    },
    getCalenderEventRingColorOnDate(date) {
      const dayStart = new Date(date.getFullYear(), date.getMonth(), date.getDate());
      const eventEntry = (Array.isArray(this.calenderEntries) ? this.calenderEntries : [])
        .map((entry) => this.normalizeCalenderEntry(entry))
        .find((entry) =>
          entry.isEvent &&
          this.isCalenderEntryOnDate(entry, dayStart)
        );

      return eventEntry ? this.getCalenderEventStyle(eventEntry).color : '';
    },
    openMonth(month) {
      this.value = new Date(this.selectedCalendarYear, month, 1);
      this.calendarMode = 'month';
    },
    openCalendarDay(date) {
      if (!date) return;
      this.openVacationDialog(date, 'Termin');
      this.calendarMode = 'month';
    },
    openCalendarYearDay(date) {
      if (!date) return;
      this.value = new Date(date.getFullYear(), date.getMonth(), date.getDate());
      this.calendarMode = 'month';
    },
    openVacationDialog(date = null, entryType = 'vacation') {
      const selectedDate = date
        ? this.toLocalIsoDate(date instanceof Date ? date : new Date(date))
        : this.toLocalIsoDate(new Date());
      const isEvent = entryType !== 'vacation';
      this.vacationForm = {
        ...defaultVacationForm(),
        name: isEvent ? entryType : 'Urlaub',
        startDate: selectedDate,
        endDate: selectedDate,
        startTime: this.isTimedCalendarEntryType(entryType) ? '09:00' : '',
        endTime: this.isTimedCalendarEntryType(entryType) ? '10:00' : '',
        entryKind: isEvent ? 'event' : 'vacation',
        eventType: isEvent ? entryType : '',
        entryType,
        recurrence: this.getDefaultRecurrenceForEntryType(entryType),
      };
      this.editingVacationId = null;
      this.vacationDialog = true;
    },
    closeVacationDialog() {
      this.vacationDialog = false;
      this.editingVacationId = null;
      this.vacationForm = defaultVacationForm();
    },
    onVacationStartDateChange(startDate) {
      if (!startDate) return;
      if (this.isBirthdayEventType(this.getVacationEventType())) {
        this.vacationForm.endDate = startDate;
        return;
      }
      if (!this.vacationForm.endDate || this.vacationForm.endDate < startDate) {
        this.vacationForm.endDate = startDate;
      }
    },
    onCalendarEntryTypeChange(entryType) {
      const eventType = this.getVacationEventType(entryType);
      const isEvent = entryType !== 'vacation';

      this.vacationForm.entryKind = isEvent ? 'event' : 'vacation';
      this.vacationForm.eventType = eventType;
      this.vacationForm.recurrence = this.getDefaultRecurrenceForEntryType(entryType);

      if (isEvent) {
        this.prefillVacationNameFromEventType(eventType);
      } else if (!this.vacationForm.name || this.eventTypeOptions.includes(this.vacationForm.name)) {
        this.vacationForm.name = 'Urlaub';
      }

      if (this.isBirthdayEventType(eventType) && this.vacationForm.startDate) {
        this.vacationForm.endDate = this.vacationForm.startDate;
      }

      if (!this.isTimedCalendarEntryType(entryType)) {
        this.vacationForm.startTime = '';
        this.vacationForm.endTime = '';
      } else {
        if (!this.vacationForm.startTime) this.vacationForm.startTime = '09:00';
        this.ensureVacationEndTimeAfterStart();
      }
    },
    onVacationEventTypeChange(eventType) {
      this.prefillVacationNameFromEventType(eventType);
      if (!this.hasYearlyDefaultRecurrence(eventType)) return;

      this.vacationForm.recurrence = 'yearly';
      if (this.vacationForm.startDate) {
        this.vacationForm.endDate = this.vacationForm.startDate;
      }
    },
    isBirthdayEventType(eventType) {
      return String(eventType || '').toLowerCase().includes('geburt');
    },
    hasYearlyDefaultRecurrence(entryType) {
      const value = String(entryType || '').trim().toLowerCase();
      return value.includes('geburt') || value === 'familie';
    },
    getDefaultRecurrenceForEntryType(entryType) {
      return this.hasYearlyDefaultRecurrence(entryType) ? 'yearly' : 'none';
    },
    getVacationEventType(entryType = this.vacationForm.entryType) {
      return entryType === 'vacation' ? '' : String(entryType || '').trim();
    },
    getCalendarEntryType(normalized) {
      if (!normalized?.isEvent) return 'vacation';
      return normalized.eventType || 'Termin';
    },
    isTimedCalendarEntryType(entryType) {
      return ['termin', 'erinnerung', 'familie'].includes(
        String(entryType || '').trim().toLowerCase()
      );
    },
    normalizeTimeValue(value) {
      if (!value) return '';
      const text = String(value).trim();
      const match = text.match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?/);
      if (!match) return '';
      const hours = Number(match[1]);
      const minutes = Number(match[2]);
      if (hours < 0 || hours > 23 || minutes < 0 || minutes > 59) return '';
      return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
    },
    addMinutesToTime(value, minutesToAdd = 60) {
      const time = this.normalizeTimeValue(value);
      if (!time) return '';

      const [hours, minutes] = time.split(':').map(Number);
      const nextTotalMinutes = Math.min((hours * 60) + minutes + minutesToAdd, (23 * 60) + 59);
      const nextHours = Math.floor(nextTotalMinutes / 60);
      const nextMinutes = nextTotalMinutes % 60;

      return `${String(nextHours).padStart(2, '0')}:${String(nextMinutes).padStart(2, '0')}`;
    },
    ensureVacationEndTimeAfterStart() {
      const startTime = this.normalizeTimeValue(this.vacationForm.startTime);
      if (!startTime) return;

      const endTime = this.normalizeTimeValue(this.vacationForm.endTime);
      if (!endTime || endTime <= startTime) {
        this.vacationForm.endTime = this.addMinutesToTime(startTime, 60);
      }
    },
    onVacationStartTimeChange() {
      this.vacationForm.startTime = this.normalizeTimeValue(this.vacationForm.startTime);
      this.ensureVacationEndTimeAfterStart();
    },
    buildCalenderDateTime(dateString, timeString = '') {
      const date = String(dateString || '').slice(0, 10);
      const time = this.normalizeTimeValue(timeString);
      return new Date(`${date}T${time || '00:00'}:00`);
    },
    prefillVacationNameFromEventType(eventType) {
      const type = String(eventType || '').trim();
      if (!type) return;

      const currentName = String(this.vacationForm.name || '').trim();
      const canReplaceName = !currentName || currentName === 'Urlaub' || this.eventTypeOptions.includes(currentName);
      if (canReplaceName) {
        this.vacationForm.name = type;
      }
    },
    normalizeCalenderEntry(entry) {
      const source = entry || {};
      const id = firstDefined(source, ['idcalender_entry', 'id']);
      const name = firstDefined(source, ['calender_name', 'name']) || 'Urlaub';
      const note = firstDefined(source, ['calender_note', 'note']) || '';
      const startDate = toIsoDateString(firstDefined(source, ['calender_start_date', 'start_date', 'start']));
      const endDate = toIsoDateString(firstDefined(source, ['calender_end_date', 'end_date', 'end']));
      const startTime = this.normalizeTimeValue(firstDefined(source, ['calender_start_time', 'start_time', 'startTime']));
      const endTime = this.normalizeTimeValue(firstDefined(source, ['calender_end_time', 'end_time', 'endTime']));
      const recurrence = String(firstDefined(source, ['calender_recurrence']) || 'none').toLowerCase();
      const isEvent = Boolean(firstDefined(source, ['calender_is_event']));
      const eventType = firstDefined(source, ['calender_event_type']) || '';
      const reminderEnabled = Boolean(firstDefined(source, ['calender_reminder_enabled', 'reminder_enabled']));
      const reminderMinutesBefore = Number(firstDefined(source, ['calender_reminder_minutes_before', 'reminder_minutes_before']) ?? 15);
      const reminderAtUtc = firstDefined(source, ['calender_reminder_at_utc', 'reminder_at_utc']) || null;

      return {
        id,
        name,
        note,
        startDate,
        endDate: endDate || startDate,
        startTime,
        endTime,
        recurrence,
        isEvent,
        eventType,
        reminderEnabled,
        reminderMinutesBefore: Number.isFinite(reminderMinutesBefore) ? reminderMinutesBefore : 15,
        reminderAtUtc,
        raw: source,
      };
    },
    buildVacationPayload() {
      const startDate = String(this.vacationForm.startDate || '').trim();
      const formEndDate = String(this.vacationForm.endDate || '').trim();
      const name = String(this.vacationForm.name || 'Urlaub').trim() || 'Urlaub';
      const note = String(this.vacationForm.note || '').trim();
      const entryType = this.vacationForm.entryType || this.vacationForm.entryKind;
      const isEvent = entryType !== 'vacation';
      const eventType = isEvent ? this.getVacationEventType(entryType) : '';
      const hasTime = this.isTimedCalendarEntryType(entryType);
      const startTime = hasTime ? this.normalizeTimeValue(this.vacationForm.startTime) : '';
      const endTime = hasTime ? this.normalizeTimeValue(this.vacationForm.endTime) : '';
      const recurrence = String(this.vacationForm.recurrence || 'none').trim() || 'none';
      const endDate = isEvent && this.isBirthdayEventType(eventType)
        ? startDate
        : formEndDate;

      return {
        calender_name: name,
        calender_note: note || null,
        calender_start_date: startDate,
        calender_end_date: endDate,
        calender_start_time: startTime || null,
        calender_end_time: endTime || null,
        calender_recurrence: recurrence,
        calender_is_event: isEvent,
        calender_event_type: eventType || null,
        calender_reminder_enabled: Boolean(this.vacationForm.reminderEnabled),
        calender_reminder_minutes_before: this.vacationForm.reminderEnabled
          ? Number(this.vacationForm.reminderMinutesBefore ?? 15)
          : null,
      };
    },
    editSelectedVacation() {
      if (!this.selectedEvent || this.selectedEvent.sourceType !== 'calender') return;

      const normalized = this.normalizeCalenderEntry(this.selectedEvent.full || this.selectedEvent);
      this.vacationForm = {
        name: normalized.name,
        startDate: normalized.startDate,
        endDate: normalized.endDate,
        startTime: normalized.startTime,
        endTime: normalized.endTime,
        note: normalized.note,
        recurrence: normalized.recurrence || 'none',
        entryKind: normalized.isEvent ? 'event' : 'vacation',
        eventType: normalized.eventType || '',
        entryType: this.getCalendarEntryType(normalized),
        reminderEnabled: normalized.reminderEnabled,
        reminderMinutesBefore: normalized.reminderMinutesBefore,
      };
      this.editingVacationId = normalized.id ?? null;
      this.eventDetailsDialog = false;
      this.vacationDialog = true;
    },
    getVisibleCalendarRange() {
      const raw = Array.isArray(this.value) ? this.value[0] : this.value;
      const base = raw instanceof Date ? raw : new Date(raw || Date.now());
      const firstOfMonth = new Date(base.getFullYear(), base.getMonth(), 1);
      const lastOfMonth = new Date(base.getFullYear(), base.getMonth() + 1, 0);
      const rangeStart = new Date(firstOfMonth);
      const rangeEnd = new Date(lastOfMonth);
      const firstWeekdayOffset = (firstOfMonth.getDay() + 6) % 7;
      const lastWeekdayOffset = (lastOfMonth.getDay() + 6) % 7;

      rangeStart.setDate(rangeStart.getDate() - firstWeekdayOffset);
      rangeEnd.setDate(rangeEnd.getDate() + (6 - lastWeekdayOffset));
      rangeEnd.setHours(23, 59, 59, 999);

      return { rangeStart, rangeEnd };
    },
    addRecurrenceStep(date, recurrence) {
      const next = new Date(date);
      switch (recurrence) {
        case 'daily':
          next.setDate(next.getDate() + 1);
          break;
        case 'weekly':
          next.setDate(next.getDate() + 7);
          break;
        case 'monthly':
          next.setMonth(next.getMonth() + 1);
          break;
        case 'yearly':
          next.setFullYear(next.getFullYear() + 1);
          break;
        default:
          return null;
      }
      return next;
    },
    getCalenderEventStyle(entry) {
      if (!entry.isEvent) {
        return {
          color: '#2196F3',
          textColor: '#ECEFF1',
        };
      }

      const eventType = String(entry.eventType || '').toLowerCase();
      if (eventType.includes('geburt')) {
        return { color: '#F06292', textColor: '#FCE4EC' };
      }
      if (eventType.includes('reise')) {
        return { color: '#26A69A', textColor: '#E0F2F1' };
      }
      if (eventType.includes('feier') || eventType.includes('feiertag')) {
        return { color: '#7E57C2', textColor: '#EDE7F6' };
      }
      if (eventType.includes('erinner')) {
        return { color: '#FFA726', textColor: '#FFF3E0' };
      }

      return {
        color: '#66BB6A',
        textColor: '#E8F5E9',
      };
    },
    buildVacationEvents(printRange = null) {
      return (Array.isArray(this.calenderEntries) ? this.calenderEntries : [])
        .map((entry) => this.normalizeCalenderEntry(entry))
        .filter((entry) => entry.startDate && entry.endDate)
        .flatMap((vacation) => {
          const baseStart = this.buildCalenderDateTime(vacation.startDate, vacation.startTime);
          const baseInclusiveEnd = this.buildCalenderDateTime(
            vacation.endDate,
            vacation.endTime || vacation.startTime
          );

          if (Number.isNaN(baseStart.getTime()) || Number.isNaN(baseInclusiveEnd.getTime())) {
            return [];
          }

          const durationDays = Math.max(
            0,
            Math.round((baseInclusiveEnd.getTime() - baseStart.getTime()) / MS_PER_DAY)
          );
          const { rangeStart, rangeEnd } = printRange || this.getVisibleCalendarRange();
          const style = this.getCalenderEventStyle(vacation);
          const events = [];
          let occurrenceStart = new Date(baseStart);
          let guard = 0;

          while (occurrenceStart <= rangeEnd && guard < (printRange ? 100000 : 500)) {
            const displayEnd = new Date(occurrenceStart);
            displayEnd.setDate(displayEnd.getDate() + durationDays);

            if (displayEnd >= rangeStart) {
              events.push({
                id: `${vacation.id}_${occurrenceStart.toISOString().slice(0, 10)}`,
                calenderEntryId: vacation.id,
                name: this.formatCalendarEventName(vacation),
                start: new Date(occurrenceStart),
                end: new Date(displayEnd),
                displayEnd,
                color: style.color,
                textColor: style.textColor,
                allDay: !vacation.startTime && !vacation.endTime,
                sourceType: 'calender',
                note: vacation.note || '',
                startTime: vacation.startTime || '',
                endTime: vacation.endTime || '',
                recurrence: vacation.recurrence || 'none',
                isEvent: vacation.isEvent,
                eventType: vacation.eventType || '',
                reminderEnabled: vacation.reminderEnabled,
                reminderMinutesBefore: vacation.reminderMinutesBefore,
                reminderAtUtc: vacation.reminderAtUtc,
                full: vacation.raw,
              });
            }

            if (vacation.recurrence === 'none') break;

            const next = this.addRecurrenceStep(occurrenceStart, vacation.recurrence);
            if (!next) break;
            occurrenceStart = next;
            guard += 1;
          }

          return events;
        });
    },
    refreshVacationEvents(activityEvents = null) {
      const baseEvents = Array.isArray(activityEvents)
        ? activityEvents
        : (Array.isArray(this.events) ? this.events.filter((event) => event.sourceType !== 'calender') : []);

      this.events = [
        ...baseEvents,
        ...this.buildVacationEvents(),
      ];
    },
    async saveVacationDraft(closeAfterSave = false) {
      const startDate = String(this.vacationForm.startDate || '').trim();
      const endDate = String(this.vacationForm.endDate || '').trim();

      if (!startDate || !endDate) return;
      if (endDate < startDate) return;
      if (this.showVacationTimeFields) {
        this.ensureVacationEndTimeAfterStart();
      }
      if (
        this.showVacationTimeFields &&
        startDate === endDate &&
        this.vacationForm.startTime &&
        this.vacationForm.endTime &&
        this.normalizeTimeValue(this.vacationForm.endTime) <= this.normalizeTimeValue(this.vacationForm.startTime)
      ) {
        return;
      }

      const payload = this.buildVacationPayload();

      let savedEntry = null;

      if (this.editingVacationId != null) {
        savedEntry = await this.updateCalenderEntry({
          id: this.editingVacationId,
          form: payload,
        });
      } else {
        savedEntry = await this.createCalenderEntry(payload);
        const savedId = firstDefined(savedEntry, ['idcalender_entry', 'id']);
        if (savedId != null) this.editingVacationId = savedId;
      }

      this.refreshVacationEvents();

      if (closeAfterSave) {
        this.closeVacationDialog();
      }
    },
    async deleteSelectedVacation() {
      if (!this.selectedEvent || this.selectedEvent.sourceType !== 'calender') return;

      const normalized = this.normalizeCalenderEntry(this.selectedEvent.full || this.selectedEvent);
      if (!normalized.id) return;

      await this.deleteCalenderEntry(normalized.id);
      this.eventDetailsDialog = false;
      this.refreshVacationEvents();
    },
      formatWindDirection(deg) {
        if (deg == null || isNaN(deg)) return '—';

        const dirs = [
          'N',        // 0
          'NNO',
          'NO',
          'ONO',
          'O',
          'OSO',
          'SO',
          'SSO',
          'S',
          'SSW',
          'SW',
          'WSW',
          'W',
          'WNW',
          'NW',
          'NNW',      // 15
        ];

        const idx = Math.round(deg / 22.5) % 16;
        return dirs[idx];
      },
        weatherIconMdi(w) {
          // w kann weatherToday oder day sein
          const owm = w?.icon;          // z.B. "10d"
          const desc = (w?.description || '').toLowerCase();

          if (!owm && !desc) return 'mdi-weather-cloudy';

          const code = (owm || '').slice(0, 2); // "01".."50"
          const night = (owm || '').endsWith('n');

          // OpenWeatherMap icon codes:
          // 01 clear, 02 few clouds, 03 scattered clouds, 04 broken clouds,
          // 09 shower rain, 10 rain, 11 thunderstorm, 13 snow, 50 mist
          switch (code) {
            case '01': return night ? 'mdi-weather-night' : 'mdi-weather-sunny';
            case '02': return night ? 'mdi-weather-night-partly-cloudy' : 'mdi-weather-partly-cloudy';
            case '03': return 'mdi-weather-cloudy';
            case '04': return 'mdi-weather-cloudy-alert';
            case '09': return 'mdi-weather-pouring';
            case '10': return 'mdi-weather-rainy';
            case '11': return 'mdi-weather-lightning-rainy';
            case '13': return 'mdi-weather-snowy';
            case '50': return 'mdi-weather-fog';

            default: {
              // Fallback über Text (falls icon fehlt)
              if (desc.includes('schnee')) return 'mdi-weather-snowy';
              if (desc.includes('gewitter')) return 'mdi-weather-lightning-rainy';
              if (desc.includes('regen') || desc.includes('schauer')) return 'mdi-weather-rainy';
              if (desc.includes('nebel') || desc.includes('dunst')) return 'mdi-weather-fog';
              if (desc.includes('wol')) return 'mdi-weather-cloudy';
              return 'mdi-weather-cloudy';
            }
          }
        },

    showEvent(event) {
      console.log('event clicked:', event); // zum Testen

      if (!event) return;

      this.selectedEvent = event;
      this.eventDetailsDialog = true;
    },

    createPrognose() {
      const acts = this.activities || [];
      if (!acts.length) {
        // reset KPIs
        this.DistanzVorletzteWoche = 0;
        this.DistanzAktuellerMonat = 0;
        this.DistanzAktuellesJahr = 0;
        this.PrognoseDistanzMonat = 0;
        this.PrognoseDistanzJahr = 0;
        this.SchnittProTag = 0;
        this.SchnittProMonat = 0;
        this.DatumDerLetztenAktivity = null;
        this.DeltaTageBisEndeMonat = 0;
        return;
      }

      // Group by ISO week
      const groupedByWeek = _.groupBy(acts, (e) =>
        isoWeekKey(new Date(e.aktivitaeten_startTimeGMT))
      );

      const weekKeysDesc = sortGroupedKeysChronoDesc(
        groupedByWeek,
        (k) => {
          const [y, w] = k.split('_').map(Number);
          // Approx parse: week start (Mon) as date for sorting
          const jan4 = new Date(Date.UTC(y, 0, 4));
          const day = jan4.getUTCDay() || 7; // 1..7
          const mondayJan4Week = new Date(jan4);
          mondayJan4Week.setUTCDate(jan4.getUTCDate() - day + 1);
          return new Date(
            mondayJan4Week.getTime() + (w - 1) * 7 * MS_PER_DAY
          );
        }
      );

      // Distanz vorletzte Woche (if available)
      if (weekKeysDesc.length >= 2) {
        const prevWeekArr = groupedByWeek[weekKeysDesc[1]];
        const distMeters = _.sumBy(prevWeekArr, 'aktivitaeten_distance') || 0;
        this.DistanzVorletzteWoche = Number(toKm(distMeters).toFixed(1));
      } else {
        this.DistanzVorletzteWoche = 0;
      }

      // Letzte Aktivität (latest by startTime)
      const latest = _.maxBy(
        acts,
        (e) => +new Date(e.aktivitaeten_startTimeGMT)
      );
      this.DatumDerLetztenAktivity = latest
        ? new Date(latest.aktivitaeten_startTimeGMT)
        : null;

      // Resttage bis Monatsende
      const today = new Date();
      const startTomorrow = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate() + 1
      );
      const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      const diffDays =
        Math.floor((lastDay - startTomorrow) / MS_PER_DAY) + 1;
      this.DeltaTageBisEndeMonat = clamp(diffDays, 0, 31);

      // Group by Year-Month
      const groupedByYM = _.groupBy(acts, (e) =>
        yearMonthKey(new Date(e.aktivitaeten_startTimeGMT))
      );

      const ymKeysDesc = sortGroupedKeysChronoDesc(
        groupedByYM,
        (k) => {
          const [y, m] = k.split('_').map(Number);
          return new Date(y, m - 1, 1);
        }
      );

      const latestMonthKey = ymKeysDesc[0];
      const currentMonthArr = groupedByYM[latestMonthKey] || [];
      const distMonthMeters =
        _.sumBy(currentMonthArr, 'aktivitaeten_distance') || 0;
      this.DistanzAktuellerMonat = Number(toKm(distMonthMeters).toFixed(1));

      // km/day average in current month
      const currentDayOfMonth = today.getDate();
      this.SchnittProTag =
        currentDayOfMonth > 0
          ? this.DistanzAktuellerMonat / currentDayOfMonth
          : 0;

      // Group by Year
      const groupedByYear = _.groupBy(
        acts,
        (e) => new Date(e.aktivitaeten_startTimeGMT).getFullYear()
      );
      const currentYear = today.getFullYear();
      const currentYearArr = groupedByYear[currentYear] || [];
      const distYearMeters =
        _.sumBy(currentYearArr, 'aktivitaeten_distance') || 0;
      this.DistanzAktuellesJahr = Number(toKm(distYearMeters).toFixed(1));

      // km/month average in current year
      const monthIndex = today.getMonth() + 1; // 1..12
      this.SchnittProMonat =
        monthIndex > 0 ? this.DistanzAktuellesJahr / monthIndex : 0;

      // Prognosen
      this.PrognoseDistanzMonat = Math.round(
        this.SchnittProTag * this.DeltaTageBisEndeMonat +
          this.DistanzAktuellerMonat
      );
      this.PrognoseDistanzJahr = Math.round(this.SchnittProMonat * 12);
    },

    // 🌦 OpenWeatherMap: aktuelles Wetter
    async getCurrentWeather() {
      const url =
        `https://api.openweathermap.org/data/2.5/weather` +
        `?q=${this.weatherCity}` +
        `&units=metric` +
        `&lang=de` +
        `&appid=${this.weatherApiKey}`;

      console.log('###>>>getCurrentWeather##:',url)

      const res = await fetch(url);
      if (!res.ok) throw new Error('Fehler beim Laden des aktuellen Wetters');
      return res.json();
    },

    // 🌦 OpenWeatherMap: 5-Tage-Vorhersage (3h Schritte)
    async getForecastWeather() {
      const url =
        `https://api.openweathermap.org/data/2.5/forecast` +
        `?q=${this.weatherCity}` +
        `&units=metric` +
        `&lang=de` +
        `&appid=${this.weatherApiKey}`;

      const res = await fetch(url);
      if (!res.ok) throw new Error('Fehler beim Laden der Vorhersage');
      return res.json();
    },

    formatForecastDate(dateStr) {
      const d = new Date(dateStr);
      return d.toLocaleDateString('de-DE', {
        weekday: 'short',
        day: '2-digit',
        month: '2-digit',
      });
    },

    buildForecastDays(forecastData) {
      // nach YYYY-MM-DD gruppieren
      const daysMap = {};
      forecastData.list.forEach(item => {
        const [date] = item.dt_txt.split(' ');
        if (!daysMap[date]) daysMap[date] = [];
        daysMap[date].push(item);
      });

      const allDates = Object.keys(daysMap).sort();
      const todayStr = new Date().toISOString().slice(0, 10);

      // die nächsten 3 Tage NACH heute
      const futureDates = allDates.filter(d => d > todayStr).slice(0, 3);

      return futureDates.map(date => {
        const entries = daysMap[date];
        const temps = entries.map(e => e.main.temp);
        const min = Math.min(...temps);
        const max = Math.max(...temps);

        // mittlerer Eintrag für die Beschreibung (z.B. mittags)
        const middle = entries[Math.floor(entries.length / 2)];
        const desc = middle.weather[0]?.description || '';
        const icon = middle.weather[0]?.icon || null;

        const hasRain = entries.some(e => e.rain && (e.rain['3h'] || e.rain['1h']));
        const rainText = hasRain ? 'Regen möglich' : 'wahrscheinlich trocken';

        return {
          date,
          dateLabel: this.formatForecastDate(date),
          min,
          max,
          description: desc,
          rainText,
          icon,          // 👈 neu
        };
      });
    },

async fetchWeather() {

  this.weatherApiKey = (this.settings || []).find(s => s.settings_key === 'weatherApiKey').settings_value;

  if (!this.weatherApiKey || this.weatherApiKey === 'DEIN_API_KEY_HIER') {
    this.weatherError = 'Kein Wetter-API-Key konfiguriert.';
    return;
  }

  this.weatherLoading = true;
  this.weatherError = null;

  try {
    const [current, forecast] = await Promise.all([
      this.getCurrentWeather(),
      this.getForecastWeather(),
    ]);

    const hasRain =
      !!current.rain &&
      (current.rain['1h'] || current.rain['3h']);

    // 🔹 WIND: m/s -> km/h + Richtung
    const windSpeedMs  = current.wind?.speed ?? null;
    const windDeg      = current.wind?.deg ?? null;

    const windSpeedKmh = windSpeedMs != null
      ? Math.round(windSpeedMs * 3.6)
      : null;

    const windDirLabel = windDeg != null
      ? this.formatWindDirection(windDeg)
      : null;

    this.weatherToday = {
      temp:        current.main.temp,
      feelsLike:   current.main.feels_like,
      description: current.weather[0]?.description || '',
      rainText:    hasRain ? 'Regen möglich' : 'geringe Regenwahrscheinlichkeit',
      icon:        current.weather[0]?.icon || null,

      // 👇 NEU
      windKmh:     windSpeedKmh,   // z.B. 6
      windDeg:     windDeg,        // z.B. 150
      windDir:     windDirLabel,   // z.B. "Süd-Südost"
    };

    this.weatherForecast = this.buildForecastDays(forecast);
  } catch (err) {
    console.error(err);
    this.weatherError = 'Wetterdaten konnten nicht geladen werden.';
  } finally {
    this.weatherLoading = false;
  }
},


    getEventAvatar(event) {
      const type = (event && event.activityType) || '';
      const name = (event && event.rawName ? event.rawName : '').toLowerCase();

      if (type === 'indoor_cycling' || name.includes('indoor')) {
        return indoorIcon;
      }
      if (type === 'mountain_biking') {
        return mtbIcon;
      }
      if (type === 'road_biking') {
        return roadIcon;
      }
      return null;
    },

    trainingEffectFarbe(aerobRaw) {
      const v = typeof aerobRaw === 'string'
        ? parseFloat(aerobRaw.replace(',', '.'))
        : Number(aerobRaw);

      if (!Number.isFinite(v)) {
        return { label: '—', fill: '#FFFFFF', font: '#000000' };
      }

      const GREEN_FILL = '#C6EFCE',  GREEN_FONT = '#006100';
      const PINK_FILL  = '#EDBA77',  PINK_FONT  = '#0a0a0a';

      if (v < 1)  return { label: 'Keine Wirkung',              fill: '#FFFFFF',  font: '#000000' };
      if (v < 2)  return { label: 'Erholung (Leicht Aerob)',    fill: GREEN_FILL, font: GREEN_FONT };
      if (v <= 3.5) return { label: 'Basis (Leicht Aerob)',     fill: GREEN_FILL, font: GREEN_FONT };
      if (v < 4)  return { label: 'Pace (Hoch Aerob)',          fill: PINK_FILL,  font: PINK_FONT };
      if (v < 5)  return { label: 'Schwelle (Hoch Aerob)',      fill: PINK_FILL,  font: PINK_FONT };
      return       { label: 'Überbelastung',                    fill: '#FFC7CE',  font: '#9C0006' };
    },

    onCalendarTouchStart(event) {
      const touch = event.changedTouches?.[0];
      if (!touch) return;

      this.calendarTouchStartX = touch.clientX;
      this.calendarTouchStartY = touch.clientY;
      this.calendarTouchStartTime = Date.now();
    },
    onCalendarTouchEnd(event) {
      const touch = event.changedTouches?.[0];
      if (
        !touch ||
        this.calendarTouchStartX === null ||
        this.calendarTouchStartY === null
      ) {
        return;
      }

      const deltaX = touch.clientX - this.calendarTouchStartX;
      const deltaY = touch.clientY - this.calendarTouchStartY;
      const elapsed = Date.now() - this.calendarTouchStartTime;
      const isHorizontalSwipe = Math.abs(deltaX) >= 60 && Math.abs(deltaX) > Math.abs(deltaY) * 1.4;
      const isIntentionalSwipe = elapsed <= 700;

      this.calendarTouchStartX = null;
      this.calendarTouchStartY = null;
      this.calendarTouchStartTime = 0;

      if (!isHorizontalSwipe || !isIntentionalSwipe) return;

      if (deltaX < 0) {
        this.next();
      } else {
        this.prev();
      }
    },
    setToday() { this.value = new Date(); },
    moveCalendarBy(amount) {
      const raw = Array.isArray(this.value) ? this.value[0] : this.value;
      const base = raw instanceof Date ? raw : new Date(raw || Date.now());
      const nextDate = new Date(base);

      if (this.calendarMode === 'year') {
        nextDate.setFullYear(nextDate.getFullYear() + amount);
      } else {
        nextDate.setMonth(nextDate.getMonth() + amount);
      }

      this.value = nextDate;
    },
    prev() { this.moveCalendarBy(-1); },
    next() { this.moveCalendarBy(1); },
    async fetchEvents() {
      await Promise.all([
        this.$store.dispatch('getActivities'),
        this.$store.dispatch('getSettings'),
        this.$store.dispatch('getCalenderEntries'),
      ]);

      const events2 = (this.activities || []).map(a => {
        const start = new Date(a.aktivitaeten_startTimeGMT);
        const end = new Date(start.getTime() + (a.aktivitaeten_duration || 0) * 1000);
        const aer = this.trainingEffectFarbe(a.aktivitaeten_aerobicTrainingEffect);

        return {
          name: a.aktivitaeten_activityName,
          start,
          end,
          color: aer.fill,
          textColor: aer.font,
          aerobLabel: aer.label,
          trainingEffect: a.aktivitaeten_aerobicTrainingEffect,
          distanceKm: Number(toKm(a.aktivitaeten_distance || 0).toFixed(1)),
          durationMin: Math.round((a.aktivitaeten_duration || 0) / 60),
          activityType: a.aktivitaeten_activityType,
          rawName: a.aktivitaeten_activityName,
          full: a, // komplette Aktivität
        };
      });

      this.refreshVacationEvents(events2);

      const lastLoginSetting = (this.settings || []).find(s => s.settings_key === 'LastGarminLogin');
      if (lastLoginSetting?.settings_value) {
        const d = new Date(lastLoginSetting.settings_value);
        if (!isNaN(d)) {
          this.LastGarminLogin = d;
          this.LastGarminLoginUhrzeit = d.toLocaleTimeString('de-DE');
          this.LastGarminLoginDisplay = d.toLocaleString('de-DE');
        }
      }

      this.createPrognose();
    },
  },


};
</script>

<style scoped>
.mini-weather-preview {
  width: min(100%, 360px);
  background: rgba(33, 150, 243, 0.06);
}

.min-width-0 {
  min-width: 0;
}

.calendar-swipe-area {
  touch-action: pan-y;
}

.calendar-today-btn {
  min-height: 40px;
  font-weight: 700;
  letter-spacing: 0.04em;
}

.calendar-nav-btn {
  width: 40px;
  height: 40px;
  border: 1px solid currentColor;
}

.calendar-day-slot {
  position: relative;
  min-height: 100%;
}

.calendar-day-create-button {
  position: absolute;
  inset: 0;
  z-index: 1;
  border: 0;
  background: transparent;
  cursor: pointer;
}

.calendar-day-tooltip {
  max-width: 280px;
  display: grid;
  gap: 4px;
  font-size: 0.8rem;
  line-height: 1.25;
}

.calendar-day-tooltip__item {
  overflow-wrap: anywhere;
}

.year-calendar-sheet {
  min-height: 600px;
}

.year-calendar-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 28px 56px;
}

.year-month {
  min-width: 0;
}

.year-month-title {
  width: 100%;
  border: 0;
  background: transparent;
  color: inherit;
  cursor: pointer;
  font: inherit;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.2;
  padding: 0 0 10px;
  text-align: left;
}

.year-weekdays,
.year-days {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
}

.year-weekdays {
  color: inherit;
  font-size: 0.75rem;
  font-weight: 600;
  margin-bottom: 4px;
  opacity: 0.72;
  text-align: center;
}

.year-day {
  position: relative;
  border: 0;
  border-radius: 999px;
  background: transparent;
  color: inherit;
  cursor: pointer;
  font: inherit;
  font-size: 0.78rem;
  font-weight: 600;
  line-height: 1;
  min-height: 30px;
  padding: 0;
}

.year-day.is-outside {
  color: inherit;
  opacity: 0.42;
  pointer-events: none;
  visibility: hidden;
}

.year-day.has-event::after {
  padding-bottom: 5px;
}

.year-day-label {
  position: relative;
  z-index: 1;
}

.year-event-dots {
  position: absolute;
  right: 50%;
  bottom: 4px;
  display: flex;
  gap: 2px;
  transform: translateX(50%);
}

.year-event-dot {
  width: 4px;
  height: 4px;
  border-radius: 999px;
}

.year-day.is-vacation {
  border-radius: 2px;
  background: #2196F3;
  color: #ECEFF1;
}

.year-day.is-calendar-event {
  border-radius: 999px;
}

.year-day.is-calendar-event .year-day-label {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 999px;
}

.year-day.is-calendar-event.has-event::after {
  display: none;
}

.year-day.is-today {
  border-radius: 999px;
  background: #FB8C00;
  color: #FFFFFF;
}

.year-day.is-vacation.is-today {
  border-radius: 999px;
  background: #FB8C00;
  color: #FFFFFF;
  box-shadow: 0 0 0 2px #FFFFFF inset;
}

.year-day.is-today.has-event::after {
  display: none;
}

.year-day.is-vacation.has-event::after {
  display: none;
}

@media (max-width: 600px) {
  .calendar-toolbar-sheet {
    height: 48px !important;
  }

  /*noinspection CssUnusedSymbol*/
  .calendar-toolbar :deep(.v-toolbar__content) {
    height: 48px !important;
    padding: 0 4px;
  }

  .calendar-month-title {
    flex: 1 1 auto;
    min-width: 0;
    margin-inline-start: 4px;
    font-size: 1rem;
    font-weight: 600;
    line-height: 1.2;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .calendar-mode-toggle {
    flex: 0 0 auto;
  }

  /*noinspection CssUnusedSymbol*/
  .calendar-mode-toggle :deep(.v-btn) {
    min-width: 36px;
    padding: 0 8px;
  }

  .calendar-swipe-area {
    height: calc(100dvh - 300px) !important;
    min-height: 390px;
    max-height: 470px;
  }

  /*noinspection CssUnusedSymbol*/
  .calendar-swipe-area :deep(.v-calendar-weekly__head-weekday) {
    font-size: 10px;
    padding: 0 1px;
  }

  /*noinspection CssUnusedSymbol*/
  .calendar-swipe-area :deep(.v-calendar-weekly__day-label) {
    margin-top: 1px;
  }

  /*noinspection CssUnusedSymbol*/
  .calendar-swipe-area :deep(.v-calendar-weekly__day-label .v-icon-btn) {
    font-size: 11px;
    min-width: 28px;
    width: 28px;
    height: 24px;
  }

  /*noinspection CssUnusedSymbol*/
  .calendar-swipe-area :deep(.v-event) {
    height: 16px !important;
    line-height: 16px !important;
  }

  .calendar-swipe-area .calendar-event-avatar {
    width: 16px !important;
    height: 16px !important;
  }

  .calendar-swipe-area .calendar-event-name {
    font-size: 10px !important;
    line-height: 16px;
  }

  .year-calendar-sheet {
    height: auto !important;
    min-height: 0;
    max-height: none;
    padding: 12px !important;
  }

  .year-calendar-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 18px;
  }

  .year-month-title {
    font-size: 0.9rem;
    padding-bottom: 6px;
  }

  .year-weekdays {
    font-size: 0.65rem;
  }

  .year-day {
    font-size: 0.7rem;
    min-height: 22px;
  }

  .year-event-dots {
    bottom: 3px;
  }

  .year-event-dot {
    width: 3px;
    height: 3px;
  }
}

@media (min-width: 601px) and (max-width: 1100px) {
  .year-calendar-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 24px 36px;
  }
}
</style>
